module.exports = __webpack_public_path__ + "img/noImg.58f7230b.svg";